// eslint-disable-next-line
export const SET_USER_SETTINGS = 'userSettings/set-user-settings';
